import * as ChannelService from '@channel.io/channel-web-sdk-loader';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useChannelTalk = () => {
  const location = useLocation();

  useEffect(() => {
    ChannelService.loadScript();
    ChannelService.boot(
      { pluginKey: '0478d5d5-405b-42d4-b699-485f000f80af', hideChannelButtonOnBoot: true },
      (error, user) => {
        if (error) {
          // channelTalk boot failed
        }
      },
    );
  }, []);

  useEffect(() => {
    ChannelService.setPage(window.location.origin + location.pathname);

    if (document.documentElement.clientWidth >= 712) {
      ChannelService.showChannelButton();
    } else if (location.pathname.includes('/home')) {
      ChannelService.showChannelButton();
    } else {
      ChannelService.hideChannelButton();
    }
  }, [location.pathname]);
};
